"use client";

import { createContext, useContext } from "react";

const PortalContainerContext = createContext<HTMLElement | undefined>(
  undefined,
);

/**
 * Provides a custom container element for Radix UI portals.
 * When set, portal-using components (Popover, Select, DropdownMenu, etc.)
 * will render into this container instead of document.body,
 * preserving CSS theme variable inheritance.
 */
export function PortalContainerProvider({
  children,
  container,
}: {
  children: React.ReactNode;
  container: HTMLElement | null;
}): React.JSX.Element {
  return (
    <PortalContainerContext.Provider value={container ?? undefined}>
      {children}
    </PortalContainerContext.Provider>
  );
}

export function usePortalContainer(): HTMLElement | undefined {
  return useContext(PortalContainerContext);
}
